import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-solutions',
    templateUrl: './solutions.component.html',
    styleUrls: ['./solutions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SolutionsComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: 'Our Solutions',
            title: 'We Different From Others Should Choose Us',
            paragraphText: 'Experience Unmatched Quality and Innovation. Our Dedicated Team Delivers Tailored IT Solutions and Top Talent, Ensuring Your Success Every Step of the Way.'
        }
    ]
    singleSolutionsBox: solutionsBoxContent[] = [
        {
            icon: 'flaticon-rocket',
            title: 'Startup Applications',
            paragraphText: 'Discover the innovative tools and solutions transforming ideas into thriving businesses. From planning and collaboration to execution and growth, explore applications designed to empower startups at every stage.',
            link: 'services-details/3',
            linkText: ''
        },
        {
            icon: 'flaticon-laptop',
            title: 'SaaS Solutions and Dedicated Team Augmentation',
            paragraphText: 'We specialize in custom web development, offering dedicated teams for your ongoing web development projects. Partner with us to elevate your digital presence and achieve your business goals',
            link: 'services-details/2',
            linkText: ''
        },
        {
            icon: 'flaticon-money',
            title: 'E-Commerce Platforms',
            paragraphText: 'Elevate Your Online Business with Our Cutting-Edge E-Commerce Solutions. Seamless, Scalable, and Designed to Boost Your Sales',
            link: 'services-details/1',
            linkText: ''
        }
    ]

}
class sectionTitleContent {
    subTitle : string;
    title : string;
    paragraphText : string;
}
class solutionsBoxContent {
    icon : string;
    title : string;
    paragraphText : string;
    link! : string;
    linkText! : string;
}